import { render, staticRenderFns } from "./common-header.vue?vue&type=template&id=5ff84c6a&scoped=true&"
import script from "./common-header.vue?vue&type=script&lang=js&"
export * from "./common-header.vue?vue&type=script&lang=js&"
import style0 from "./common-header.vue?vue&type=style&index=0&id=5ff84c6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff84c6a",
  null
  
)

export default component.exports